<template>
  <div>
    <h1 class="align-center">Images uploading</h1>
    <form :action="`${imageSetApi.base_url}/${id}/upload-image`" method="post" class="dropzone-area dropzone" id="uploadIllustrationDZ">

    </form>

    <div class="align-center vertical-padding">
      <router-link class="big-purple-button"
                   :to="{name: 'portfolio.collection.edit-images', params: {id}}">Continue</router-link>
    </div>
  </div>
</template>

<script>
import imageSetApi from './../../../../api/image-set';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    }
  },
  data() {
    return {
      imageSetApi,
      imageUploading: false,
    };
  },
  mounted() {
    this.setupDropzone();
  },
  methods: {
    setupDropzone() {
      let self = this;

      Dropzone.autoDiscover = false;
      Dropzone.options.uploadIllustrationDZ = {
        paramName: 'image',
        parallelUploads: 10,
        dictDefaultMessage: 'Drop files here to upload',
        timeout: configs.dropzoneTimeout,
        params: {
          image_set_id: self.id,
        },
        init: function() {
          this.on("addedfile", function(file) {
            self.imageUploading = true;
          });
        },
        error: function (f, data) {
          self.imageUploading = false;

          let firstErrorKey = Object.keys(data.errors)[0],
            firstError = data.errors[firstErrorKey][0];    //Get first error

          f.previewElement.classList.add("dz-error");
          f.previewElement.querySelector("[data-dz-errormessage]").textContent = firstError;
        },
        success: function (f, image) {
          f.previewElement.classList.add("dz-success");

          self.imageUploading = false;
        }
      };

      $("#uploadIllustrationDZ").dropzone();
    }
  },
};
</script>

<style>
  .dropzone-area {
    min-height: 180px;
    background: white;
    padding: 20px 20px;
    border: 2px dashed #6e1b56;
    border-radius: 5px;
  }

  .dropzone, .dz-message {
    text-align: center;
    margin: 2em 0;
  }

  #uploadIllustrationDZ {
    max-width: 655px;
  }
</style>